const JOB_ACTION_CARD_CONSTANT = {
  DEFAULT: 'default',
  PASSEDTEST_NOTBOOKTI: 'passedtest_notbookti',
  BOOKEDTI_FUTUREDATE: 'bookedti_futuredate',
  BOOKEDTI_PASSED: 'bookedti_passed',
  CONSIDERED: 'considered',
  ANOTHER_PICKED: 'another_picked',
  BOOKEDTI_FAILED: 'bookedti_failed', /** Result is out and candidate failed */
  SELF_PICKED: 'self_picked',
  NOTESTPASSED: 'notestpassed',
  PASSEDTI_LACKOFTESTS: 'passedti_lackoftests',
  PASSEDTI_FOUNDELIGIBLEJOB: 'passedti_foundeligiblejob',
  ELIGIBLE: 'eligible',
  ALMOST_ELIGIBLE: 'almost eligible',
  NOT_ELIGIBLE: 'not eligible',
  BOOKTI_NOTPASSED: 'bookedti_notpassed' /** Candidate still awaiting result */
};

export default JOB_ACTION_CARD_CONSTANT;
